import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
} from '@mui/material';
import React from 'react';
import TruncatedText from '../atoms/truncated-text/truncated-text';

interface FilterItemProps {
  label: string;
  value: string;
  count?: number;
  id?: string;
}

interface FilterGroupProps {
  refine: (value: string) => void;
  items: FilterItemProps[];
  selected: string[];
}

const FilterGroup = ({ items, refine, selected }: FilterGroupProps) => {
  return (
    <FormControl sx={{ mx: 3, my: 1 }} component="fieldset" variant="standard">
      <FormGroup>
        {items.map((item, i) => (
          <FormControlLabel
            key={i}
            control={
              <Checkbox
                checked={selected.includes(item.value.toString())}
                onChange={() => refine(item.value)}
                name={item.label}
                id={item.id}
              />
            }
            label={
              <TruncatedText
                text={item.label}
                sx={{ textTransform: 'capitalize' }}
                maxCharacters={35}
                variant="inherit"
              />
            }
          />
        ))}
      </FormGroup>
    </FormControl>
  );
};

export default React.memo(FilterGroup);
